import React, { useState, useRef } from "react";
import "./EvToggle.css";
import { useEvMode } from "../../context/EvModeContext";

const SPARKS = ["t1","t2","t3","b1","b2","l","r"];

export default function EvToggle() {
  const { evMode, setEvMode } = useEvMode();
  const on = evMode;
  const [flashing, setFlashing] = useState(false);
  const flashTimer = useRef(null);

  const handleToggle = () => {
    if (flashing) return;
    const next = !on;
    setEvMode(next);
    if (next) {
      setFlashing(true);
      clearTimeout(flashTimer.current);
      flashTimer.current = setTimeout(() => setFlashing(false), 2100);
    }
  };

  const cls = [
    "ev-tog",
    on ? "ev-tog--on" : "",
    flashing ? "ev-tog--flash" : "",
  ].filter(Boolean).join(" ");

  return (
    <div className="ev-tog-wrap">
      {!on && <>
        <span className="ev-pulse ev-pulse-1" />
        <span className="ev-pulse ev-pulse-2" />
        <span className="ev-pulse ev-pulse-3" />
      </>}
      {on && SPARKS.map(id => (
        <span key={id} className={`ev-spark ev-spark-${id}`} />
      ))}
      <div
        className={cls}
        onClick={handleToggle}
        role="switch"
        aria-checked={on}
        tabIndex={0}
        onKeyDown={e => (e.key === " " || e.key === "Enter") && handleToggle()}
      >
        <div className="ev-tog-inner">
          <svg className="ev-tog-bolt" width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.5 1L1 8h4.5L4 13l6-7H5.5L6.5 1Z" fill="#7eb8ff" stroke="#4fc3f7" strokeWidth="0.4" strokeLinejoin="round"/>
          </svg>
          <span className="ev-tog-label">EV</span>
          <div className="ev-tog-track">
            <div className="ev-tog-thumb" />
          </div>
        </div>
      </div>
    </div>
  );
}
